// extracted by mini-css-extract-plugin
export default {"MaskedIcon":"icon_MaskedIcon__ON8PV"};